import { WboAnnotationDocumentMetadata, WboConnectionStatusObserver, WboDelta, WboRequestMessage, WboServerResponse, WboTransportProvider } from '@webcat/wbo-client';
import { RequestProvider } from '@/shared/providers/request.provider';

/**
 * A transport provider that uses HTTP to communicate with the server.
 * This is suitable for request/response patterns but does not support real-time updates like WebSocket.
 */
export default class WboHttpTransportProvider implements WboTransportProvider {

    constructor(private boardName: string) {
    }
    removeConnectionStatusObserver(observer: WboConnectionStatusObserver): void {
    }

    addConnectionStatusObserver(observer: WboConnectionStatusObserver): void {
    }

    close(): void {
        // No persistent connection to close for HTTP
    }

    initialize(): void {
        // HTTP doesn't need initialization like WebSocket connections
        this.notifyObservers(observer => observer.onConnect());
    }

    isConnected(): boolean {
        // For HTTP, we consider it always "connected" if we can make requests
        return true;
    }

    onMessage(handler: (delta: WboDelta) => void): void {
        // HTTP transport doesn't have persistent messaging like WebSocket
        // This would need to be implemented with polling or Server-Sent Events
        throw new Error('HTTP transport does not support real-time messaging. Use sendRequest for request/response patterns.');
    }

    sendDelta(message: WboDelta): void {
        throw new Error('HTTP transport does not support fire-and-forget messaging. Use sendRequest instead.');
    }

    sendDeltaWithAck(message: WboDelta): Promise<WboServerResponse | undefined> {
        throw new Error('HTTP transport does not support delta messaging. Use sendRequest instead.');
    }

    async sendRequest(wboRequest: WboRequestMessage): Promise<any> {
        const url = `boards/${this.boardName}/deltas/composed?includeMetadata=true`;
        const response = await RequestProvider.requestWbo('GET', url, {}, wboRequest.request);
        return response;
    }

    subscribe(boardName: string, boardMetadata: WboAnnotationDocumentMetadata): void {
        // For HTTP, subscription might be a one-time setup call
        this.notifyObservers(observer => observer.onSubscribe());
    }

    private notifyObservers(callback: (observer: WboConnectionStatusObserver) => void): void {
    }
}
